/**
 * Template Utilities
 *
 * Functions for cloning and filling HTML <template> elements using data-slot attributes.
 */

/**
 * Clone a <template> element by its id.
 *
 * @param {string} id - The template element id
 * @returns {DocumentFragment} Cloned template content
 */
export function cloneTemplate(id) {
  const tpl = document.getElementById(id);
  if (!tpl) {
    console.error(`Template not found: #${id}`);
    return document.createDocumentFragment();
  }
  return tpl.content.cloneNode(true);
}

/**
 * Fill data-slot elements in a fragment with text content.
 *
 * @param {DocumentFragment} fragment - The cloned template fragment
 * @param {Object} data - Map of slot names to text values
 * @returns {DocumentFragment} The same fragment (for chaining)
 */
export function fillSlots(fragment, data) {
  for (const [key, value] of Object.entries(data)) {
    const el = fragment.querySelector(`[data-slot="${key}"]`);
    if (el) {
      el.textContent = value ?? "";
    }
  }
  return fragment;
}

/**
 * Fill data-slot elements in a fragment with HTML content.
 *
 * @param {DocumentFragment} fragment - The cloned template fragment
 * @param {Object} data - Map of slot names to HTML strings
 * @returns {DocumentFragment} The same fragment (for chaining)
 */
export function fillHtmlSlots(fragment, data) {
  for (const [key, value] of Object.entries(data)) {
    const el = fragment.querySelector(`[data-slot="${key}"]`);
    if (el) {
      el.innerHTML = value ?? "";
    }
  }
  return fragment;
}
